import { jwtDecode } from "jwt-decode";
import {IdTokenPayload} from "./IdTokenPayload";

enum Role {
    ENERSOUND_BACKOFFICE_USER = "Enersound.BackofficeUser",
    INTERPRETATION_BASICUSER = "Interpretation.BasicUser",
    INTERPRETATION_SUPERADMIN = "Interpretation.SuperAdmin"
}

export enum Resource {
    BACKOFFICE = "BACKOFFICE",
    INTERPRETER = "INTERPRETER",
    BILLING = "BILLING",
    BROADCAST_TRANSCRIPT = "BROADCAST_TRANSCRIPT"
}

const methodVsRoles: Record<Resource, Role[]> = {
    [Resource.BACKOFFICE]: [Role.ENERSOUND_BACKOFFICE_USER],
    [Resource.INTERPRETER]: [Role.INTERPRETATION_BASICUSER, Role.INTERPRETATION_SUPERADMIN, Role.ENERSOUND_BACKOFFICE_USER],
    [Resource.BILLING]: [Role.INTERPRETATION_SUPERADMIN, Role.ENERSOUND_BACKOFFICE_USER],
    [Resource.BROADCAST_TRANSCRIPT]: []
};

export const checkUserAllowed = (userRoles: string[], resource: Resource): boolean => {
    const roles= userRoles;

    if (!roles || roles.length === 0) {
        throw new Error("Unauthorized: No roles in token");
    }

    const allowedRoles = methodVsRoles[resource];
    console.log("allowedRoles: " + allowedRoles)
    if (!allowedRoles || allowedRoles.length === 0) {
        throw new Error("Unauthorized: No roles allowed");
    }

    for (const role of roles) {
        console.log('checking role: ' + role, allowedRoles)
        if (allowedRoles.some(r => r === role)) {
            return true;
        }
    }
    throw new Error("Unauthorized: Role not allowed" + roles);
};

/*export const checkUserAllowed = (authorization: string, resource: Resource): string => {
    if (!authorization) {
        throw new Error("Unauthorized");
    }

    const decode = jwtDecode<IdTokenPayload>(authorization.replace("Bearer ", ""));
    const username = decode.preferred_username;
    const roles= decode.roles;

    console.log("roles: " + roles)

    if (!roles || roles.length === 0) {
        throw new Error("Unauthorized: No roles in token");
    }

    const allowedRoles = methodVsRoles[resource];
    console.log("allowedRoles: " + allowedRoles)
    if (!allowedRoles || allowedRoles.length === 0) {
        throw new Error("Unauthorized: No roles allowed");
    }

    for (const role of roles) {
        console.log('checking role: ' + role, allowedRoles)
        if (allowedRoles.some(r => r === role)) {
            return username;
        }
    }
    console.log("fack")

    throw new Error("Unauthorized: Role not allowed" + roles);
};*/
